import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import heroEnDesktop from "../../assets/landing/hero-en-desktop.jpg";
import heroEnMobile from "../../assets/landing/hero-en-mobile.jpg";
import heroZhDesktop from "../../assets/landing/hero-zh-desktop.jpg";
import heroZhMobile from "../../assets/landing/hero-zh-mobile.jpg";
import { PUBLICATIONS } from "./constants";
import type { LandingLang } from "./constants";
import styles from "./LandingPage.module.scss";

const HERO_IMAGES: Record<LandingLang, { desktop: string; mobile: string }> = {
  en: { desktop: heroEnDesktop, mobile: heroEnMobile },
  zh: { desktop: heroZhDesktop, mobile: heroZhMobile },
};

interface LandingBodyProps {
  lang: LandingLang;
}

export default function LandingBody({ lang }: LandingBodyProps): ReactElement {
  const { t } = useTranslation("landing");

  const hero = HERO_IMAGES[lang];
  const singleCopySubtitle = t("singleCopySubtitle");

  return (
    <main className={styles.mainContent}>
      <div className={styles.contentWrapper}>
        <div className={styles.heroSection}>
          <picture>
            <source media="(min-width: 769px)" srcSet={hero.desktop} />
            <img
              src={hero.mobile}
              alt={t("heroTitle")}
              className={styles.heroImage}
            />
          </picture>
        </div>

        <h1 className={styles.heroTitle}>{t("heroTitle")}</h1>
        <p className={styles.heroSubtitle}>{t("heroSubtitle")}</p>

        <div className={styles.pubGrid}>
          {PUBLICATIONS[lang].map((pub) => (
            <a
              key={pub.id}
              href={t(`links.publications.${pub.id}`)}
              className={styles.pubCard}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={pub.logo}
                alt={t(`publications.${pub.id}`)}
                className={styles.pubLogo}
              />
              <span className={styles.pubName}>
                {t(`publications.${pub.id}`)}
              </span>
            </a>
          ))}
        </div>

        <div className={styles.divider}>
          <span className={styles.dividerText}>{t("or")}</span>
        </div>

        <div>
          <h2 className={styles.singleCopyTitle}>{t("singleCopyTitle")}</h2>
          {singleCopySubtitle && (
            <p className={styles.singleCopySubtitle}>{singleCopySubtitle}</p>
          )}
          <a
            href={t("links.buyToday")}
            className={styles.buyButton}
            target="_blank"
            rel="noreferrer"
          >
            {t("buyToday")}
          </a>
        </div>
      </div>
    </main>
  );
}
